import type { UnsavedChangesState } from './reducer'

export const SET_UNSAVED_CHANGES = 'UNSAVED_CHANGES_SET' as const
export const CLEAR_UNSAVED_CHANGES = 'UNSAVED_CHANGES_CLEAR' as const

export const setUnsavedChanges = (payload: UnsavedChangesState) => ({
  type: SET_UNSAVED_CHANGES,
  payload,
})

export const clearUnsavedChanges = () => ({
  type: CLEAR_UNSAVED_CHANGES,
})

export type UnsavedChangesAction =
  | ReturnType<typeof setUnsavedChanges>
  | ReturnType<typeof clearUnsavedChanges>
